import { OverlayTrigger, Tab, Tabs, Tooltip } from "react-bootstrap";
import UnForm from "../../../../../Components/Form";
import {
    faDownload,
    faFileUpload,
    faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ChangeEvent, useRef, useState } from "react";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import {
    ExportarPlanilhaContatoAudienciaController,
    ImportarPlanilhaContatoAudienciaController,
} from "../../../../../Controllers/Automacao/Contato/ContatoControllers";
import { saveAs } from "file-saver";
import { Spinner } from "../../../../../Components/Loding/SpinnerPadrao";
import { IContato } from "../../../../../Interfaces/Automacao/Audiencia/AudienciaInterfaces";
import Swal from "sweetalert2";

interface IVincularContatosEmMassa {
    ID_AUDIENCIA: number;
    lstContatosExec: (...args: any[]) => Promise<IContato[]>;
}

export default function VincularContatosEmMassa(
    props: IVincularContatosEmMassa
) {
    const [file, setFile] = useState<File>();
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleFileUpload = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            const uploadedFile = e.target.files[0];
            setFile(uploadedFile);
        }
    };

    const handleFileRemove = () => {
        setFile(undefined);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    const {
        execute: ExportarPlanilhaContatoAudiencia,
        loading: ExportarPlanilhaContatoAudienciaLoading,
    } = useAsyncCallback(ExportarPlanilhaContatoAudienciaController);

    const {
        execute: ImportarPlanilhaContatoAudiencia,
        loading: ImportarPlanilhaContatoAudienciaLoading,
    } = useAsyncCallback(ImportarPlanilhaContatoAudienciaController);

    function handleImportarPlanilhaContatos() {
        if (!file) {
            Swal.fire("Por favor, selecione um arquivo antes de importar.");
            return;
        }

        ImportarPlanilhaContatoAudiencia(props.ID_AUDIENCIA, file).then(() => {
            props.lstContatosExec();
        });
    }

    return (
        <Tabs defaultActiveKey="download">
            <Tab title="Baixar Planilha Modelo" eventKey="download">
                <div className="d-flex justify-content-end">
                    <button
                        className="btn btn-outline-success mt-8 mx-0"
                        onClick={() => {
                            ExportarPlanilhaContatoAudiencia(
                                props.ID_AUDIENCIA
                            ).then((res) => {
                                if (res) {
                                    const blob = new Blob([res], {
                                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                    });
                                    saveAs(
                                        blob,
                                        `Planilha Modelo - Contatos Audiência ${props.ID_AUDIENCIA}.xlsx`
                                    );
                                }
                            });
                        }}
                        disabled={ExportarPlanilhaContatoAudienciaLoading}
                    >
                        {ExportarPlanilhaContatoAudienciaLoading ? (
                            <Spinner size="sm" />
                        ) : (
                            <FontAwesomeIcon
                                icon={faDownload}
                                className="mr-2"
                            />
                        )}{" "}
                        Baixar Planilha Modelo
                    </button>
                </div>
            </Tab>
            <Tab title="Importar planilha" eventKey="upload">
                <UnForm
                    handleSubmit={handleImportarPlanilhaContatos}
                    className="d-flex align-items-center my-4"
                >
                    <div className="w-50 mx-5">
                        <div>
                            <label htmlFor="formFile" className="mb-0 w-75">
                                Importar Planilha
                            </label>
                            <div className="custom-file mr-2 mt-1 position-relative file-input-container">
                                <input
                                    type="file"
                                    className="custom-file-input"
                                    accept=".xlsx, .xls"
                                    id="formFile"
                                    onChange={handleFileUpload}
                                    ref={fileInputRef}
                                />
                                <label
                                    className="custom-file-label"
                                    htmlFor="formFile"
                                >
                                    {file?.name || "Escolher arquivo..."}
                                </label>
                                {file && (
                                    <OverlayTrigger
                                        overlay={
                                            <Tooltip id="ver-info-tooltip">
                                                Remover arquivo
                                            </Tooltip>
                                        }
                                    >
                                        <button
                                            onClick={handleFileRemove}
                                            className="btn remove-file-btn"
                                        >
                                            <FontAwesomeIcon
                                                icon={faTimes}
                                                color="red"
                                            />
                                        </button>
                                    </OverlayTrigger>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="w-25 mt-auto">
                        <UnForm.SubmitButton
                            className="btn btn-success w-100"
                            iconSize="sm"
                            loadingSize="sm"
                            color="success"
                            icon={faFileUpload}
                            disabled={ImportarPlanilhaContatoAudienciaLoading}
                            loading={ImportarPlanilhaContatoAudienciaLoading}
                        >
                            Importar Planilha
                        </UnForm.SubmitButton>
                    </div>
                </UnForm>
            </Tab>
        </Tabs>
    );
}
